import getSimpleDateString from './getSimpleDateString';
export default function dateAIsAfterB(a, b) {
    return getSimpleDateString(a) > getSimpleDateString(b);
}
